import styled from "styled-components"
import { validColor, darkBorder, darkFontColor, darkBackground } from "./helpers"
import { StyledTelephoneWrapper } from "./StyledTelephoneWrapper"

export const StyledFieldWrapper = styled.div`
    /* display: ${({ hidden }) => (hidden ? "none" : "grid")}; */
    ${({ hidden }) => (hidden ? (`
        display: none;
        height: 0;
        width: 0;
    `) : (`
        display: grid;
    `))}
    align-content: flex-start;
    ${props => props.half ? `
        grid-column: span 1 / auto;
    ` : `
        grid-column: span 2 / auto;
    `}

    ${props => props.loading && `
        opacity: .5;
        pointer-events: none;
    `}

    & > div{
        position: relative;
    }

    & i{
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;

        & svg{
            ${props => props.valid === undefined || props.valid === null ? `
                color: ${props.theme.colors.darkGrey};
            ` : `
                color: ${props.valid === false ? "#FA5C66" : "#0E6D63"};
            `};
        }
    }
    & label{
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translateY(-50%);
        font-family: 'EFCircularWeb-Book';
        line-height: 20px;
        font-size: 16px;
        pointer-events: none;
        transition: .2s;
        color: ${props => props.theme.colors.darkGrey};
        @media (max-width: 1024px){
            font-size: 14px;
            line-height: 18px;
        }
    }
    & select, & input, & textarea{
        background: white;
        color: ${props => props.theme.colors.darkGrey};
        width: 100%;
        font-family: 'EFCircularWeb-Book';
        padding: 16px;
        line-height: 20px;
        font-size: 16px;
        border: 1px solid rgba(0,0,0,0.25);
        border-radius: 4px;
        @media (max-width: 1024px){
            font-size: 14px;
            line-height: 18px;
        }
        
        &:valid, &:focus, &.has_placeholder{
            padding: 24px 16px 8px;

            & ~ label{
                transform: translateY(0);
                top: 8px; 
                line-height: 18px;
                font-size: 14px;
                opacity: .6;

                @media (max-width: 1024px){
                    font-size: 12px;
                    line-height: 16px;
                }
            }  
        }
    }
    
    & select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: none;
    }
    
    & input{
        ${props => !props.empty && `
            padding: 24px 16px 8px;

            & ~ label{
                transform: translateY(0);
                top: 8px; 
                line-height: 18px;
                font-size: 14px;
                opacity: .6;

                @media (max-width: 1024px){
                    font-size: 12px;
                    line-height: 16px;
                }
            }  
        `}
    }
    & textarea{
        & ~ label{
            top: 16px;
            transform: translateY(0);
        }
        &:valid, &:focus, &.has_placeholder{
            padding: 24px 16px 8px;

            & ~ label{
                transform: translateY(0);
                top: 0px; 
                width: calc(100% - 32px);
                padding: 8px 0 0 0;
                background: white;
                color: #808080;
                line-height: 18px;
                font-size: 14px;
                opacity: 1;

                @media (max-width: 1024px){
                    font-size: 12px;
                    line-height: 16px;
                }
            }  
        }
    }

    & span{
        color: #FA5C66;
        font-family: 'EFCircularWeb-Book';
        line-height: 18px;
        font-size: 14px;
        margin-top: 4px;
        @media (max-width: 1024px){
                    font-size: 12px;
                    line-height: 16px;
                }
    }

    ${props => props.phone && `
        grid-column: span 2 / auto;
        grid-template-columns: repeat(6, 1fr);
        column-gap: 8px;

        & > div{
            grid-column: span 2 / auto;
            align-content: initial;

            &:nth-of-type(2){
                grid-column: span 4 / auto;
            }
        }
        & > span{
            grid-column: span 6 / auto; 
        }
    `}

    /* Change the white to any color */
& input:-webkit-autofill, & select:-webkit-autofill,
& input:-webkit-autofill:hover, & select:-webkit-autofill:hover, 
& input:-webkit-autofill:focus, & select:-webkit-autofill:focus,
& input:-webkit-autofill:active, & select:-webkit-autofill:active{
    padding: 24px 16px 8px;

            & ~ label{
                transform: translateY(0);
                top: 8px; 
                line-height: 18px;
                font-size: 14px;
                opacity: .6;

                @media (max-width: 1024px){
                    font-size: 12px;
                    line-height: 16px;
                }
            }  

}
`

export const StyledLookupOptions = styled.div`
    ${props => !props.visible && `
        opacity: 0;
        pointer-events: none;
    `}

    background: ${props => props.theme.colors.white};
    border: 1px solid rgba(0,0,0,0.25);
    padding: 8px;
    position: absolute;
    top: calc(100% - 1px);
    width: 100%;
    max-height: 175px;
    overflow-y: scroll;
    left: 0;
    z-index: 1;
    border-radius: 4px;
    box-shadow: 0 16px 16px rgba(0,0,0,0.15);

    & > div{
        padding: 8px;
        border-radius: 4px;
        cursor: pointer;
        transition: .2s;
        font-size: 16px;
        line-height: 20px;
        font-family: ${props => props.theme.fonts.circularBook};
        color: ${props => props.theme.colors.darkGrey};
        display: flex;
        flex-direction: column;
        @media (max-width: 1024px){
            font-size: 14px;
            line-height: 18px;
        }
        &:hover{
            background: ${props => props.theme.colors.darkGrey05};
        }
    }
`
export const StyledSelectedOption = styled.div`
    padding: 24px 16px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgba(0,0,0,0.25);
    border-radius: 4px;
    cursor: pointer;
    
    background: ${props => props.theme.colors.white};
    
    & > span{
        position: absolute;
        left: 16px;
        font-family: 'EFCircularWeb-Book';
        pointer-events: none;
        transition: .2s;
        color: ${props => props.theme.colors.darkGrey};
        transform: translateY(0);
        top: 8px; 
        line-height: 18px;
        font-size: 14px;
        opacity: .6;
        margin: 0;

        @media (max-width: 1024px){
            font-size: 12px;
            line-height: 16px;
        }
    }
    & > p{
        font-family: ${props => props.theme.fonts.circularBook};
        line-height: 20px;
        font-size: 16px;
        color: ${props => props.theme.colors.darkGrey};

        @media (max-width: 1024px){
            font-size: 14px;
            line-height: 18px;
        }
    }

    & > i{
        line-height: 1;
        height: 16px;
        width: 16px;
        display: flex;
        align-items: center;

        @media (max-width: 1024px){
            height: 14px;
        width: 14px;
        }

        & svg{
            color: ${props => props.theme.colors.darkGrey};
        }
    }
`

export const StyledLoading = styled.div`
  position: absolute;
  right: 32px;
  top: 50%;
  transform: translateY(-50%);

  & i {
    svg {
      color: ${(props) => props.theme.colors.darkGrey};
    }
  }
`